"use client";

import { c as _c } from "react/compiler-runtime";
import CollectionCardMetadataRow from "@/components/collection-page/CollectionCardMetadataRow";
import CollectionCardMetricLine from "@/components/collection-page/CollectionCardMetricLine";
import NFTImage from "@/components/nft-image/NFTImage";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { VolumeType } from "@/entities/INFT";
import { numberWithCommas, printMintDate } from "@/helpers/Helpers";
import { getNftMimeType } from "@/helpers/nft.helpers";
import { MemesSort } from "@/types/enums";
import Link from "next/link";
function getVolume(nft: NFTWithMemesExtendedData, volumeType: VolumeType) {
  let vol = 0;
  switch (volumeType) {
    case VolumeType.HOURS_24:
      vol = nft.total_volume_last_24_hours;
      break;
    case VolumeType.DAYS_7:
      vol = nft.total_volume_last_7_days;
      break;
    case VolumeType.DAYS_30:
      vol = nft.total_volume_last_1_month;
      break;
    case VolumeType.ALL_TIME:
      vol = nft.total_volume;
      break;
  }
  if (vol > 0) {
    return `${numberWithCommas(Math.round(vol * 100) / 100)} ETH`;
  }
  return "-";
}
function getNftMetricText(nft: NFTWithMemesExtendedData, sort: MemesSort, volumeType: VolumeType) {
  switch (sort) {
    case MemesSort.AGE:
    case MemesSort.MEME:
      return printMintDate(nft.mint_date);
    case MemesSort.EDITION_SIZE:
      return `Edition Size: ${numberWithCommas(nft.supply)}`;
    case MemesSort.TDH:
      return `TDH: ${numberWithCommas(Math.round(nft.boosted_tdh))}`;
    case MemesSort.HODLERS:
      return `Collectors: ${numberWithCommas(nft.hodlers)}`;
    case MemesSort.UNIQUE_PERCENT:
      return `Unique: ${Math.round(nft.percent_unique * 100 * 10) / 10}%`;
    case MemesSort.UNIQUE_PERCENT_EX_MUSEUM:
      return `Unique Ex-Museum: ${Math.round(nft.percent_unique_cleaned * 100 * 10) / 10}%`;
    case MemesSort.FLOOR_PRICE:
      return nft.floor_price > 0 ? `Floor Price: ${numberWithCommas(Math.round(nft.floor_price * 1000) / 1000)} ETH` : "Floor Price: N/A";
    case MemesSort.HIGHEST_OFFER:
      return nft.highest_offer > 0 ? `Highest Offer: ${numberWithCommas(Math.round(nft.highest_offer * 1000) / 1000)} ETH` : "Highest Offer: N/A";
    case MemesSort.MARKET_CAP:
      return nft.market_cap > 0 ? `Market Cap: ${numberWithCommas(Math.round(nft.market_cap * 100) / 100)} ETH` : "Market Cap: N/A";
    case MemesSort.VOLUME:
      return `Volume (${volumeType}): ${getVolume(nft, volumeType)}`;
  }
}
export default function TheMemesCard(t0) {
  const $ = _c(29);
  const {
    nft,
    sort,
    volumeType,
    hasConnectedProfile
  } = t0;
  let t1;
  if ($[0] !== nft) {
    t1 = getNftMimeType(nft);
    $[0] = nft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mediaMimeType = t1;
  let t2;
  if ($[2] !== nft || $[3] !== sort || $[4] !== volumeType) {
    t2 = getNftMetricText(nft, sort, volumeType);
    $[2] = nft;
    $[3] = sort;
    $[4] = volumeType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const metricText = t2;
  const t3 = `/the-memes/${nft.id}`;
  let t4;
  if ($[6] !== nft) {
    t4 = <div className="tw-bg-iron-900"><NFTImage nft={nft} animation={false} height={300} showThumbnail={true} showBalance={false} /></div>;
    $[6] = nft;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== nft.name) {
    t5 = <div className="tw-w-full tw-max-w-full tw-text-center tw-text-sm tw-font-semibold tw-leading-snug tw-text-iron-50 md:tw-text-md">{nft.name}</div>;
    $[8] = nft.name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `${nft.contract}-${nft.id}`;
  let t7;
  if ($[10] !== hasConnectedProfile || $[11] !== nft.contract || $[12] !== nft.id) {
    t7 = {
      contract: nft.contract,
      tokenId: nft.id,
      show: hasConnectedProfile
    };
    $[10] = hasConnectedProfile;
    $[11] = nft.contract;
    $[12] = nft.id;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== mediaMimeType || $[15] !== nft.id || $[16] !== t6 || $[17] !== t7) {
    t8 = <CollectionCardMetadataRow tokenId={nft.id} mediaMimeType={mediaMimeType} mediaBadgeId={t6} align="center" ownership={t7} />;
    $[14] = mediaMimeType;
    $[15] = nft.id;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== metricText) {
    t9 = <CollectionCardMetricLine text={metricText} align="center" />;
    $[19] = metricText;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t5 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-items-center tw-px-2 tw-pb-4 tw-pt-4 tw-text-center md:tw-px-4">{t5}{t8}{t9}</div>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t3 || $[27] !== t4) {
    t11 = <Link href={t3} className="tw-group tw-block tw-min-w-0 tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950 tw-text-iron-100 tw-no-underline tw-transition tw-duration-200 hover:tw-border-white/20 hover:tw-bg-iron-900/50 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400">{t4}{t10}</Link>;
    $[25] = t10;
    $[26] = t3;
    $[27] = t4;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}